import 'react-dates/initialize';
import React, { useState, useCallback } from 'react';
import classnames from 'clsx';
import moment from 'moment';

import style from './date-picker-dropdown.module.css';
import { CalendarDatePicker } from '../calendar-date-pickers/calendar-date-picker';
import { Dropdown } from '../INTERNAL/dropdown';
// @ts-expect-error less import

/**
 * @typedef {import('./date-picker-dropdown-types.d.ts').DatePickerDropdownComponent} DatePickerDropdownComponent
 */

/**
 * @param {React.MouseEvent} e
 * @returns {boolean}
 */
const shouldAllowDropdownToClose = (e) => {
  const target = /** @type {HTMLElement} */ (e.target);
  if (!target || !target.classList || !target.classList.length) {
    return false;
  }
  return [...new Set(target.classList)].some((cssClass) => cssClass.indexOf('day-button-') !== -1);
};

/**
 * @deprecated Use `DatePickerInput` from `@mantine/dates` instead.
 * See: ui-components/readme-documentation/MIGRATION.md
 * @type {DatePickerDropdownComponent}
 */
export const DatePickerDropdown = ({
  id,
  value,
  calendarPosition = 'bottom-left',
  className = '',
  openTogglerClassName = '',
  children,
  dateFormat = 'MM/DD/YYYY',
  verticalSpacing = -20,
  allowPastDates = false,
  isOutsideRange = null,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const onClose = useCallback(() => setIsOpen(false), []);

  const onOpen = useCallback(() => setIsOpen(true), []);

  /**
   * @param {string | import('moment').Moment} newDate
   */
  const change = useCallback(
    (newDate) => {
      onChange(newDate);
      if (isOpen) {
        onClose();
      }
    },
    [isOpen, onChange, onClose],
  );

  const currentDate = moment(new Date());
  return (
    <Dropdown
      closeWhenChildrenClicked={false}
      containerAllowedMeToClose={(e) => shouldAllowDropdownToClose(e)}
      id={id}
      isOpen={isOpen}
      menuPosition={calendarPosition}
      onClose={onClose}
      onOpen={onOpen}
      openTogglerClassName={openTogglerClassName}
    >
      {children}
      <div className={classnames(className, style['single-date-picker'])}>
        {isOpen ? (
          <CalendarDatePicker
            allowPastDates={allowPastDates}
            dateFormat={dateFormat}
            isOutsideRange={isOutsideRange}
            onChange={change}
            value={value || currentDate}
            verticalSpacing={verticalSpacing}
          />
        ) : null}
      </div>
    </Dropdown>
  );
};
